var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtoileRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1804_16068)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1804_16068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.971 12.393C23.8745 7.18634 25.3251 4.58301 27.4953 4.58301C29.6655 4.58301 31.1162 7.18634 34.0197 12.393L34.7714 13.7405C35.5964 15.2209 36.0089 15.9611 36.6505 16.4493C37.2922 16.9374 38.0943 17.1184 39.6985 17.4805L41.156 17.8105C46.7935 19.087 49.6099 19.724 50.2814 21.8805C50.9505 24.0347 49.0301 26.2828 45.187 30.7768L44.1924 31.9386C43.1016 33.2151 42.5539 33.8545 42.3087 34.6428C42.0635 35.4334 42.146 36.2859 42.311 37.9886L42.4622 39.5401C43.042 45.5374 43.333 48.5349 41.5776 49.8663C39.8222 51.2001 37.1822 49.9832 31.9068 47.554L30.5387 46.9261C29.0399 46.234 28.2905 45.8903 27.4953 45.8903C26.7001 45.8903 25.9507 46.234 24.4497 46.9261L23.0862 47.554C17.8085 49.9832 15.1685 51.1978 13.4153 49.8686C11.6576 48.5349 11.9487 45.5374 12.5285 39.5401L12.6797 37.9909C12.8447 36.2859 12.9272 35.4334 12.6797 34.6451C12.4368 33.8545 11.8891 33.2151 10.7982 31.9409L9.80366 30.7768C5.96054 26.2851 4.04012 24.037 4.70929 21.8805C5.38075 19.724 8.1995 19.0847 13.837 17.8105L15.2945 17.4805C16.8964 17.1184 17.6962 16.9374 18.3401 16.4493C18.9818 15.9611 19.3943 15.2209 20.2193 13.7405L20.971 12.393Z",
    fill: "#FFC657"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1804_16068",
    x: 0.578125,
    y: 2.58301,
    width: 53.8359,
    height: 53.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1804_16068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1804_16068",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1804_16068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtoileRating);
export default __webpack_public_path__ + "static/media/Etoile_rating.55c3f7e2.svg";
export { ForwardRef as ReactComponent };